<template>
    <div :class="[ 'message', shit$(``)]">
        <i :class="['el-icon-loading']"></i> dasdad
    </div>
</template>

<script>
export default {

}
</script>

<style scoped>
    .message {
        width: 200px;
        height: 40px;
        background-color: #ffffff;
        -webkit-transform: translateX(-50%);
        transform: translateX(-50%);
    }
</style>